import { Method } from 'axios';
import ApiRoutes from './ApiRoutes';
import config from '../../config';
import { ICartApiAccessTokenData } from '../common/interfaces/cart-api.interface';

const ORDERSBACKEND_BASEURL: string = config.api.baseurl + config.api.paths.orders.basepath;

export default class OrdersBackendRoutes<TResponse = undefined, TRequestData = undefined, TRequestParams = undefined> extends ApiRoutes<TResponse, TRequestData, TRequestParams> {
  public static getAccessToken = new OrdersBackendRoutes<ICartApiAccessTokenData>(`/auth/token`, `get`, true);

  constructor(url: string, method: Method, withCredentials = false) {
    super(url, method, withCredentials, ORDERSBACKEND_BASEURL);
  }
}
